import { Link } from "react-router-dom";

export const Logo = ({ compact = false, light = false }) => {
  const main = light ? "text-white" : "text-gray-900";
  return (
    <Link to="/" data-testid="logo-link" className="flex items-center gap-2 group">
      <span className="inline-flex items-center justify-center w-9 h-9 bg-[#FF5A00] text-white font-display font-extrabold text-lg rounded-sm shrink-0">
        A+
      </span>
      <span className={`leading-none ${compact ? "hidden sm:flex" : "flex"} flex-col`}>
        <span className={`font-display font-extrabold tracking-tight text-base ${main}`}>AA+PLUS</span>
        <span className="font-display font-semibold tracking-[0.2em] text-[10px] text-[#FF5A00]">MILJØSANERING</span>
      </span>
    </Link>
  );
};
